import { Card } from "primereact/card"
import { Dialog } from "primereact/dialog"
import { Toast } from "primereact/toast"
import { InputComponent } from "../../components/InputComponent";
import { PermisoServicio } from "../../service/PermisoServicio";
import { GenericComponent } from "../../components/GenericComponent";
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Permisos } from "../../models/Permisos";
import { Toolbar } from "primereact/toolbar";
import { Generico } from "../../components/Generico";
import { Divider } from "primereact/divider";

export const Permiso = () => {

    const generic = new GenericComponent();
    const omodel = new Permisos();
    const { accionesTbl } = Generico();
    const [permss, setPermss] = useState(null);
    const model = omodel.model;
    const defaultValues = generic.default(model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const toast = useRef(null);
    const [permisos, setPermisos] = useState(null);
    const { table, setLoading, setTotalRecords, lazyParams, inText, inDrop, inChips } = InputComponent({ registers: permisos, omodel, generic, errors, control, permss, id: getValues('id') });
    const permisoService = new PermisoServicio();
    const [catalogo, setCatalogo] = useState(null);
    const [dialogPermiso, setDialogPermiso] = useState(false);
    const [item, setItem] = useState(null);

    useEffect(() => {
        loadLazyPermiso();
    }, [lazyParams]);

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el permiso?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarPermiso()
        });
    }

    const eliminarPermiso = () => {
        permisoService.eliminar(item.id).then(res => {
            loadLazyPermiso();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const openNew = () => {
        permisoService.newPermiso({ iniciar: 1 }).then(res => {
            setCatalogo(res.data);
            reset(defaultValues);
            setDialogPermiso(true);
        });
    }

    const loadLazyPermiso = () => {
        setLoading(true);

        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        permisoService.getLista({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setPermisos(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
        });
    }

    const onSubmit = (data) => {
        let formatoString = "";
        if (data.desencriptar_chip && data.desencriptar_chip.length > 0) { // El orden de la interfaz es importante
            formatoString += "d:" + data.desencriptar_chip.join(',');
        }
        if (data.encriptar_chip && data.encriptar_chip.length > 0) {
            if (formatoString !== "") formatoString += "|"; // Si ya agregamos 'dec', ponemos el separador '|'
            formatoString += "e:" + data.encriptar_chip.join(',');
        }
        data.formato = formatoString; // String preparado que espera el backend
        delete data.desencriptar_chip;
        delete data.encriptar_chip;
        if (getValues('id') == null) {
            permisoService.newPermiso(data).then(res => {
                setDialogPermiso(false);
                loadLazyPermiso();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            permisoService.editarPermiso(data).then(res => {
                setDialogPermiso(false);
                loadLazyPermiso();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editPermiso = () => {
        permisoService.consultarPermiso(item.id).then(res => {
            const _cat = res.data.catalogo;
            setCatalogo(res.data.catalogo);
            const lista = { estado: generic.estados, padre: _cat.lista, metodo: _cat.metodo, crud: _cat.crud };
            const _perm = res.data.permiso;
            Object.keys(lista).forEach(function (key) {
                if (_perm[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _perm[key]) {
                            _perm[key] = element;
                        }
                    });
                }
            });
            // Formato esperado: "d:campo1,campo2|e:campo3"
            let decList = [];
            let encList = [];
            if (_perm.formato) {
                const parts = _perm.formato.split('|');
                parts.forEach(p => {
                    if (p.startsWith('d:')) decList = p.substring(2).split(',');
                    if (p.startsWith('e:')) encList = p.substring(2).split(',');
                });
            }
            // Asignamos a los campos auxiliares
            _perm.desencriptar_chip = decList;
            _perm.encriptar_chip = encList;
            reset(generic.renewValues(_perm, model));
            setDialogPermiso(true);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editPermiso() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, '', permss)}></Toolbar>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Card>
            <Dialog visible={dialogPermiso} header={getValues('id') == null ? "Nuevo Permiso" : "Editar permiso"} modal className="p-fluid modal-ssize"
                onHide={e => setDialogPermiso(false)} style={{ maxWidth: '1000px' }} >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        <div className="col-12 md:col-12 mt-4">
                            <Divider align="left">
                                <div className="inline-flex align-items-center">
                                    <i className="pi pi-lock mr-2"></i>
                                    <b>Configuración Permiso</b>
                                </div>
                            </Divider>
                        </div>
                        {inDrop('padre', catalogo?.lista, { lab: omodel.optionLabel, obl: 'no' })}
                        {inDrop('metodo', catalogo?.metodo, { lab: omodel.optionLabel, obl: 'no' })}
                        {inText('controlador', { obl: 'no' })}
                        {inText('accion', { obl: 'no' })}

                        {inDrop('crud', catalogo?.crud, { lab: omodel.optionLabel, obl: 'no' })}
                        {inDrop('estado', generic.estados, { lab: omodel.optionLabel })}
                        <div className="col-12 md:col-12 mt-4">
                            <Divider align="left">
                                <div className="inline-flex align-items-center">
                                    <i className="pi pi-lock mr-2"></i>
                                    <b>Configuración de Ofuscación (Seguridad)</b>
                                </div>
                            </Divider>
                        </div>

                        {inChips('desencriptar_chip', { etiqueta: 'Campos a Desencriptar', helpText: 'Escriba las claves que llegan encriptadas (URL o Body). Ej: cat_id', max: 195 }, 6)}
                        {inChips('encriptar_chip', { etiqueta: 'Campos a Encriptar', helpText: 'Escriba las claves de la respuesta JSON que deben ser ocultadas. Ej: id', max: 195 }, 6)}
                    </div>
                    {generic.buttonsForms(setDialogPermiso)}
                </form>
            </Dialog>
        </>
    )
}
